import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, combineLatest, map, take } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class UserGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    this.authService.redirectionUrl = state.url;
    return combineLatest([this.authService.isAdmin, this.authService.isUser]).pipe(
      take(1),
      map(([isAdmin, isUser]) => {
        if (isAdmin || isUser) {
          return true;
        }
        
        if (this.authService.currentUser) {
          // Logged in but no valid role
          this.router.navigate(['/unauthorized']);
        } else {
          // Not logged in
          this.router.navigate(['/login']);
        }
        return false;
      })
    );
  }
}
